// extracted by mini-css-extract-plugin
module.exports = {"button":"StripeApplePayButton_button__lJTKc","logo":"StripeApplePayButton_logo__g3tl8"};